import { Pipe, PipeTransform } from '@angular/core';
import {AppState} from '../store/AppState';
import {Store} from '@ngrx/store';
import {getCities} from '../store/cities/selectors';
import {map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Pipe({
  name: 'cityById',
})
export class CityByIdPipe implements PipeTransform {
  transform(cityId: number, prefix: string): Observable<string> {
    if (cityId === null) {
      return of('по Україні');
    }
    return this.store$.select(getCities).pipe(
      map(cities => {
        const city = cities.find(city_ => city_.id === cityId);
        if (city) {
          prefix = prefix ? `${prefix} ` : '';
          return `${prefix}${city.name}`;
        }
        return '';
      }),
    );
  }

  constructor(private store$: Store<AppState>) {}
}
